import { render } from "./Maze.vue?vue&type=template&id=6ba36e1b&scoped=true"
import script from "./Maze.vue?vue&type=script&lang=js"
export * from "./Maze.vue?vue&type=script&lang=js"

import "./Maze.vue?vue&type=style&index=0&id=6ba36e1b&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ba36e1b"]])

export default __exports__